import React, { useState, useEffect } from "react";
import { Card } from "@/components/ui/card";
import { backendApi } from "@/api/backendApi";

const steps = [
  { label: "Actively searching jobs", value: "actively_searching" },
  { label: "Preparing for interviews", value: "preparing" },
  { label: "Appearing for interviews", value: "interviewing" },
  { label: "Received a job offer", value: "offered" },
  { label: "Casually exploring jobs", value: "casually_exploring" },
  { label: "Not looking for jobs", value: "not_looking" },
];

export default function SearchStatusWidget() {
  const [status, setStatus] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // Fetch current status on mount
    backendApi.user.getJobStatus()
      .then(res => {
        if (res.status) setStatus(res.status);
      })
      .catch(err => console.error("Error fetching job status:", err));
  }, []);

  const handleClick = async (value) => {
    const previousStatus = status;
    setStatus(value); // Optimistic update
    setLoading(true);

    try {
      await backendApi.user.updateJobStatus({ status: value });
    } catch (err) {
      console.error("Failed to update status:", err);
      setStatus(previousStatus); // Rollback
      alert("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card className="p-5 rounded-2xl border border-gray-100 shadow-sm mb-4">
      <div className="mb-4">
        <p className="text-xs text-[#2557a7] font-medium mb-1">Needs attention</p>
        <h3 className="text-sm font-bold text-gray-900">
          Where are you in your job search journey?
        </h3>
      </div>

      <div className="space-y-2">
        {steps.map((step, i) => {
          const isActive = status === step.value;
          return (
            <button
              key={i}
              onClick={() => handleClick(step.value)}
              disabled={loading}
              className={`w-full text-left px-4 py-2 rounded-full border text-xs font-medium transition ${
                isActive
                  ? "border-[#2557a7] bg-[#2557a7] text-white"
                  : "border-gray-200 text-gray-600 hover:border-[#2557a7] hover:text-[#2557a7] hover:bg-blue-50 bg-white"
              }`}
            >
              {step.label}
            </button>
          );
        })}
      </div>
    </Card>
  );
}
